export interface CreateUserRequest {
  username: string;
  password: string;
  role: "admin" | "user";
}

export interface UserResponse {
  id: number;
  username: string;
  role: "admin" | "user";
}

export async function createUser(
  data: CreateUserRequest,
): Promise<UserResponse> {
  const response = await fetch("/api/users", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Failed to create user");
  }

  return response.json();
}

export async function listUsers(): Promise<UserResponse[]> {
  const response = await fetch("/api/users", {
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Failed to load users");
  }

  return response.json();
}
